import linkifyStr from 'linkify-string';
import { PHONE_NUMBER_REGEX } from './is-phone-number.util';

export const linkifyPhoneNumbers = (text: string) => {
  // Add a .tel suffix for the phone numbers to be detected as a url by linkify
  const textWithTelSuffix = text.replace(PHONE_NUMBER_REGEX, (r) => `${r}.tel`);

  return linkifyStr(textWithTelSuffix, {
    attributes: {
      rel: 'noopener noreferrer',
      target: '_blank',
      style: 'color: inherit; font-weight: inherit;',
    },

    // Remove the .tel suffix from the phone number text
    format: (value: string) => value.replaceAll('.tel', ''),
    // Remove the .tel suffix from the phone number href, replace http:// with tel: and remove any dashes
    formatHref: (href: string) =>
      href.replace('.tel', '').replace('http://', 'tel:').replaceAll('-', ''),
  });
};
